import { render, staticRenderFns } from "./units.vue?vue&type=template&id=6f83f94e&scoped=true"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"
import style0 from "./units.vue?vue&type=style&index=0&id=6f83f94e&prod&lang=scss&scoped=true"
import style1 from "./units.vue?vue&type=style&index=1&id=6f83f94e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83f94e",
  null
  
)

export default component.exports